var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('div',{staticClass:"card-body"},[_c('AutocompleteInput',{attrs:{"formGroupComponent":"FormGroupRow","label":"Реферал","item":_vm.item,"attribute":"referral","resource":"contact"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }